<script lang="ts">
    export let fill: string = "none";
    export let height: string = "22";
    export let width: string = "22";
    export let x: string = "0";
    export let y: string = "0";
</script>

<svg {x} {y} {width} {height} viewBox="0 0 22 22" {fill} xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="10" width="14" height="2" transform="translate(0,1)"/>
</svg>
